import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { TEXT_STYLES } from 'TEXT_STYLES'

import { CloseIconRound } from 'icons/CloseIconRound/CloseIconRound'
import { SearchIcon } from 'icons/SearchIcon/SearchIcon'

import { NakedButton } from 'ui_elements/NakedButton/NakedButton'
import { TextInput } from 'ui_elements/TextInput/TextInput'
import { LoadingPlaceholderGradient } from '@junglescout/edna'

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${props => props.theme.colors.coolGrey300};
  border-radius: 2px;
  width: 235px;
  padding-right: 10px;
`
const SearchInput = styled(TextInput)`
  ${TEXT_STYLES.BodyBlack};
  border: none;
  margin: 0;
  height: 34px;
  min-height: 34px;
`

const SearchBar = ({
  className,
  placeholder,
  handleSubmit,
  term,
  isLoading
}) => {
  const { t } = useTranslation('generic')
  const [searchTerm, setSearchTerm] = useState(term)
  // Add double check with searchTerm.length for cases when component re-renders
  const [hasSearchActive, setHasSearchActive] = useState(!!searchTerm.length)

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSubmit(searchTerm)
      setHasSearchActive(true)
    }
  }

  const handleSearchIconClick = () => {
    handleSubmit(searchTerm)
    setHasSearchActive(true)
  }

  const handleClearSearch = () => {
    handleSubmit('')
    setSearchTerm('')
    setHasSearchActive(false)
  }

  if (isLoading) {
    return <LoadingPlaceholderGradient height="32px" width="235px" />
  }

  return (
    <SearchWrapper className={className}>
      <SearchInput
        placeholder={placeholder}
        onChange={e => setSearchTerm(e.target.value)}
        onKeyPress={handleKeyPress}
        value={searchTerm}
      />
      {hasSearchActive ? (
        <NakedButton onClick={handleClearSearch} aria-label="clear-search">
          <CloseIconRound title={t('generic:Clear', 'Clear')} />
        </NakedButton>
      ) : (
        <NakedButton onClick={handleSearchIconClick}>
          <SearchIcon color="grey600" />
        </NakedButton>
      )}
    </SearchWrapper>
  )
}

SearchBar.defaultProps = {
  className: undefined,
  placeholder: 'Please input your search term',
  isLoading: false,
  term: ''
}

SearchBar.propTypes = {
  className: PropTypes.string,
  term: PropTypes.string,
  placeholder: PropTypes.string,
  isLoading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired
}

export { SearchBar }
